var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_730_4238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9944 79.9887C62.0826 79.9887 79.9887 62.0826 79.9887 39.9944C79.9887 17.9061 62.0826 0 39.9944 0C17.9061 0 0 17.9061 0 39.9944C0 62.0826 17.9061 79.9887 39.9944 79.9887Z",
    fill: "url(#paint0_linear_730_4238)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_730_4238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.617 23.4572C56.3404 24.1222 56.383 25.2445 55.7021 25.9511L26.9362 56.4181C26.2553 57.1247 25.1064 57.1662 24.383 56.5012C23.6596 55.8362 23.617 54.7139 24.2979 54.0073L53.1064 23.5819C53.7872 22.8753 54.9362 22.8337 55.6596 23.4988L55.617 23.4572ZM29.1915 27.1149C31.1915 27.1149 32.8085 28.6944 32.8085 30.6479C32.8085 32.6015 31.1915 34.1809 29.1915 34.1809C27.1915 34.1809 25.5745 32.6015 25.5745 30.6479C25.5745 28.6944 27.1915 27.1149 29.1915 27.1149ZM29.1915 23.5819C33.1489 23.5819 36.383 26.7408 36.383 30.6063C36.383 34.4719 33.1489 37.6308 29.1915 37.6308C25.234 37.6308 22 34.4719 22 30.6063C22 26.7408 25.234 23.5819 29.1915 23.5819ZM54.4255 49.3936C54.4255 47.4401 52.8085 45.8606 50.8085 45.8606C48.8085 45.8606 47.1915 47.4401 47.1915 49.3936C47.1915 51.3472 48.8085 52.9266 50.8085 52.9266C52.8085 52.9266 54.4255 51.3472 54.4255 49.3936ZM58 49.3936C58 45.5281 54.766 42.3692 50.8085 42.3692C46.8511 42.3692 43.617 45.5281 43.617 49.3936C43.617 53.2592 46.8511 56.4181 50.8085 56.4181C54.766 56.4181 58 53.2592 58 49.3936Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_730_4238",
    x1: 39.9944,
    y1: 0,
    x2: 39.9944,
    y2: 79.9887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D008B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_730_4238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_730_4238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    fill: "white",
    transform: "translate(22 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.f143c4093b64fe25cefcfff034738c5f.svg";
export { ForwardRef as ReactComponent };